import { buildUrl } from "helpers";
import { instance } from "libs/api";

import {
  ApiRoutesSupport,
  SupportConversationSubRoute
} from "../../constants/enums";
import { InAppConversationMessagesResponse } from "../../support.types";
import { GetConversationMessagesParams } from "./getConversationMessages.types";

export const requestGetConversationMessages = async ({
  conversationId,
  ...params
}: GetConversationMessagesParams): Promise<InAppConversationMessagesResponse> => {
  return await instance.get(
    buildUrl(
      ApiRoutesSupport.Conversations,
      conversationId,
      SupportConversationSubRoute.Messages
    ),
    { params }
  );
};
